import { StyleSheet } from "react-native";
import color from "@constants/color";
import { fontFamily, fontSize } from "@utils/styles/fonts";

// Semantic color aliases used throughout Login screens
const textPrimary = color.Gray20; // #333333
const textMuted = color.color_808080; // closest to #8F92A1 — muted label/placeholder
const borderDefault = color.color_D9D9D9; // #D9D9D9 ≈ #DDDDDD
const inputBg = color.lightGray; // #F8F8F8
const placeholderColor = color.disableFont; // rgba(189,189,189,1) ≈ #BCBCBC
const separatorColor = color.mercury; // #E5E5E5 ≈ #E0E0E0
const disabledBg = color.disableGrey; // rgba(236,236,236,1) ≈ #DADADA
const linkBlue = color.blue; // #4874FE ≈ #2195F2

export const loginStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  // Top hero area — takes ~60% of screen
  heroArea: {
    backgroundColor: color.white,
  },
  logoContainer: {
    padding: 16,
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  headerCreateAccountText: {
    color: linkBlue,
  },
  // Bottom card overlaps hero
  bottomCard: {
    backgroundColor: color.white,
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 28,
  },
  title: {
    color: textPrimary,
    marginBottom: 6,
  },
  subtitle: {
    color: textMuted,
    marginBottom: 24,
  },
  phoneLabel: {
    color: textMuted,
    marginBottom: 6,
    marginLeft: 4,
  },
  phoneInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 10,
    paddingHorizontal: 16,
    height: 51,
    marginBottom: 24,
    backgroundColor: inputBg,
  },
  phoneInputContainerFocused: {
    borderWidth: 1,
    borderColor: color.primary,
  },
  phoneInputContainerError: {
    borderWidth: 1,
    borderColor: color.errorRed,
  },
  countryCode: {
    fontSize: fontSize.base,
    fontFamily: fontFamily.medium,
    color: textMuted,
    marginRight: 10,
  },
  separator: {
    width: 1,
    height: 28,
    backgroundColor: separatorColor,
    marginRight: 12,
  },
  phoneInput: {
    flex: 1,
    fontSize: fontSize.base,
    fontFamily: fontFamily.regular,
    color: textPrimary,
    padding: 0,
  },
  getOtpButton: {
    borderRadius: 12,
    paddingVertical: 14,
    alignItems: "center",
    height: 47,
    justifyContent: "center",
  },
  getOtpButtonText: {
    color: color.white,
  },
  errorContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: -16,
    marginBottom: 12,
    marginLeft: 4,
  },
  errorText: {
    color: color.errorRed,
    marginLeft: 4,
  },
});

export const otpStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  contentContainer: {
    paddingHorizontal: 24,
    paddingTop: 40,
    flex: 1,
  },
  title: {
    fontSize: 22,
    fontFamily: fontFamily.bold,
    color: textPrimary,
    marginBottom: 8,
  },
  subtitle: {
    color: textMuted,
    marginBottom: 4,
  },
  phoneNumber: {
    fontSize: 15,
    fontFamily: fontFamily.bold,
    color: textPrimary,
    marginBottom: 36,
  },
  otpContainer: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 14,
    marginBottom: 24,
  },
  otpInput: {
    width: 60,
    height: 60,
    borderWidth: 1.5,
    borderColor: borderDefault,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.white,
  },
  otpInputFocused: {
    borderColor: color.primary,
    borderWidth: 2,
  },
  otpInputFilled: {
    borderColor: textPrimary,
    borderWidth: 1.5,
  },
  otpDigit: {
    fontSize: 22,
    fontFamily: fontFamily.bold,
    color: textPrimary,
  },
  hiddenOtpInput: {
    position: "absolute",
    width: 1,
    height: 1,
    opacity: 0,
  },
  timerContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
  },
  timerText: {
    fontSize: 15,
    fontFamily: fontFamily.medium,
    color: textMuted,
  },
  resendText: {
    fontSize: 15,
    fontFamily: fontFamily.bold,
    color: color.primary,
  },
  verifyButton: {
    borderRadius: 12,
    paddingVertical: 14,
    alignItems: "center",
    height: 47,
    justifyContent: "center",
  },
  verifyButtonText: {
    color: color.white,
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: color.extraLightBlack,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
});

// Exported for use in LoginPhone
export { placeholderColor, disabledBg };
